<template>
  <div class="member-cert">
    <el-tabs class="el-tabs-custom mtabs" v-model="activeTab" @tab-click="onClickTab">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <CourseCert
      ref="cert"
      :url="'/api/app/user/cert/' + activeTab"
      isMember
      @load="onLoad"
    ></CourseCert>
  </div>
</template>
<script>
import CourseCert from '@/modules/stu/components/rich/CourseCert.vue';
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'MemberCert',
  components: { CourseCert },
  data() {
    return {
      activeTab: '1',
      tabs: [
        { name: '1', label: '已获取' },
        { name: '2', label: '待获取' },
      ],
      list: [],
    };
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    onLoad() {
      triggerLoaded(this);
    },
    async refresh() {
      await this.$nextTick();
      this.$refs.cert.searchRefresh();
    },
    onClickTab() {
      this.refresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.mtabs {
  padding-top: 12px;
  padding: 12px 24px 0 24px;
}
.member-cert {
  background: #fff;
  ::v-deep {
    .course-certs {
      padding: 12px 24px 30px 24px;
    }
    .course-cert {
      padding-bottom: 24px;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    .pager {
      padding-bottom: 30px !important;
    }
  }
}
</style>
